import * as Yup from "yup";

export const rpmBillingValidationSchema = Yup.object({
  account: Yup.string().required("Account is required"),
  billingDate: Yup.string().required("Billing Date is required"),
});
